/**
 * @file 規約同意
 *
 */
'use strict';
import Common from '../../Utils/Common';

/**
 * @classname CheckAgree
 * @classdesc 規約同意
 */
export default class CheckAgree {
	/**
	 * @constructor
	 * @param {jQuery} $e - #agree
	 */
	constructor($e) {
		console.log('CheckAgree.constructor');
		this._$e = $e;
		$e.on('click', () => this.checkAgree());
	};


	/**
	 * clickのコールバック
	 *
	 * @memberof CheckAgree
	 * @return {undefined}
	 */
	checkAgree() {
		console.log('CheckAgree.checkAgree');
		const $btn = $('button[type=submit][data-form]');
		const $agree = $('#agree');
		const $ageVerification = $('#age-verification');
		const isBothExist = ($agree.length && $ageVerification.length) ? true : false;
		let isChecked = false;

		if (isBothExist) {
			isChecked = ($agree.prop('checked') && $ageVerification.prop('checked')) ? true : false;
		} else {
			isChecked = this._$e.prop('checked');
		}

		if(isChecked){
			$btn.prop('disabled', false);
		}else{
			$btn.prop('disabled', true);
		}
	};
}
